import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { ActionRow } from './components/ActionRow'
import { BorrowRow } from './components/BorrowRow'
import { TokenBalance } from './components/TokenBalance'
import { WalletPanelContent } from './components/WalletPanelContent'
import { Token } from '@/domain/types/Token'
import { BorrowEligibilityStatus } from '@/features/sparklend/common/data/market-info/reserve-status'

export interface MyWalletProps {
  token: Token
  tokenBalance: NormalizedNumber
  deposit: {
    available: NormalizedNumber
    token: Token
    openDepositDialog: () => void
    disabled?: boolean
  }
  borrow: {
    available: NormalizedNumber
    token: Token
    eligibility: BorrowEligibilityStatus
    openBorrowDialog: () => void
  }
}

export function MyWallet({ token, tokenBalance, deposit, borrow }: MyWalletProps) {
  return (
    <WalletPanelContent>
      <h3 className="typography-heading-4 text-primary">My Wallet</h3>
      <TokenBalance token={token} balance={tokenBalance} />
      {deposit.disabled ? null : (
        <ActionRow
          token={deposit.token}
          value={deposit.available}
          onAction={deposit.openDepositDialog}
          label="Available to deposit"
          buttonText="Deposit"
        />
      )}
      <BorrowRow
        token={borrow.token}
        onAction={borrow.openBorrowDialog}
        availableToBorrow={borrow.available}
        eligibility={borrow.eligibility}
      />
    </WalletPanelContent>
  )
}
